import {
    IntentKind,
    makeIntentBuilderFunction,
    makeIntentGuard,
} from '@jet-app/music-classical/intents';
import type { Intent } from '@jet/environment/dispatching';

export interface ModifyPlaylistIntent extends Intent<any> {
    $kind: IntentKind.MODIFY_PLAYLIST_INTENT;
    url?: string;
    actionType: 'addToPlaylist' | 'create' | 'editPlaylist';
    name?: string;
    description?: string;
    playlistId?: string;
    songs: string[];
    librarySongs?: any[];
    offset?: number;
}

export const isModifyPlaylistIntent = makeIntentGuard<ModifyPlaylistIntent>(
    IntentKind.MODIFY_PLAYLIST_INTENT,
);

export const makeModifyPlaylistIntent =
    makeIntentBuilderFunction<ModifyPlaylistIntent>(
        IntentKind.MODIFY_PLAYLIST_INTENT,
    );
